import { LogOptions, LogSenderInfo } from "./model";
import StorageManager from "./storageManager";

class LogSender {
  private LOG_URL = "https://weblog.woowa.in/v2/jsonlog/";
  private logStorage: StorageManager;
  private requestUrl: string;
  private timer: any;
  private requestInterval: number;

  private requestLog(records: any[]) {
    const reqTimestamp = Date.now();

    return this.sendLog(this.requestUrl, {
      reqTimestamp,
      records
    });
  }

  private sendLog(url: string, data: { reqTimestamp: number; records: any[] }) {
    const xmlHttp = new XMLHttpRequest();
    xmlHttp.open("post", url, true);
    xmlHttp.setRequestHeader(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );

    xmlHttp.onload = () => {
      if (xmlHttp.readyState === 4) {
        if (xmlHttp.status === 200) {
          this.senderClear();
        } else {
          console.error(xmlHttp.statusText);
        }
      }
    };

    xmlHttp.onerror = () => {
      console.error(xmlHttp.statusText);
    };

    xmlHttp.send(`log=${escape(JSON.stringify(data))}`);
  }

  private senderClear() {
    this.logStorage.clear();

    if (!this.timer) return;
    this.setTimer(this.requestInterval);
  }

  private setTimer(requestInterval: number) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      const records = this.logStorage.getLogs;
      if (!records.length) this.requestLog(records);
    }, requestInterval * 1000);
  }

  pushLog({ data }: { data: any }) {
    this.logStorage.push(data, this.requestLog.bind(this));
  }

  init(
    senderInfo: LogSenderInfo,
    options: LogOptions = {
      useBuffer: false,
      recordsLimit: 20,
      requestInterval: 10
    }
  ) {
    const { table, env } = senderInfo;
    const { useBuffer, requestInterval, recordsLimit } = options;

    this.requestUrl = `${this.LOG_URL}${table}/${env}`;
    this.requestInterval = requestInterval;
    this.logStorage = new StorageManager({ recordsLimit, useBuffer });

    if (!!requestInterval && useBuffer) this.setTimer(requestInterval);
  }
}

export default LogSender;
